<template>
  <footer>
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-3 text-center text-md-start">
          &copy; {{year}} mtms Solutions GmbH
        </div>
        <div class="col d-flex justify-content-center justify-content-md-end flex-wrap">
          <a class="footer__link flex-fill" href="https://ticketorganizer.eu/faq.html?lang=de&amp;backUrl=https%3A%2F%2ticketoprganizer.eu%2Fstanton-wahlabos%2Findex.html%3Flang%3Dde" data-translate="FOOTER_FAQ">FAQ</a>
          <a class="footer__link flex-fill js-footer-contact" href="mailto:info@stantonamarlberg.com" data-translate="FOOTER_CONTACT">Kontakt</a>
          <a class="footer__link flex-fill" href="https://ticketorganizer.eu/mttterms/ticketing/de" target="_blank" data-translate="FOOTER_FOR_ORGANIZERS">Für Veranstalter</a>
          <a class="footer__link flex-fill" href="https://ticketorganizer.eu/mttterms/terms/de" target="_blank" data-translate="FOOTER_TERMS_AND_CONDITION">Verkaufsbedingungen</a>
          <a class="footer__link flex-fill" href="https://ticketorganizer.eu/mttterms/privacy/de" target="_blank" data-translate="FOOTER_PRIVACY_POLICY">Datenschutz</a>
          <a class="footer__link flex-fill" href="https://ticketorganizer.eu/mttterms/cookie/de" target="_blank" data-translate="FOOTER_COOKIE_POLICY">Cookie-Richtlinie</a>
          <a class="footer__link flex-fill" href="https://ticketorganizer.eu/mttterms/imprint/de" target="_blank" data-translate="FOOTER_IMPRINT">Impressum</a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  data: function () {
    return {
      year: new Date().getFullYear()
    }
  }
}
</script>

<style scoped>
footer {
  background-color: #333333;
  color: #ffffff;
  text-transform: uppercase;
  min-height: 90px;
  padding-top: 35px;
  padding-bottom: 30px;
  font-size: 0.75rem;
  font-weight: bold;
}
.footer__link,.footer__link:hover {
  color: #ffffff;
  text-decoration: none;
  text-align: center;
}
@media (max-width: 576px) {
  .footer__link {
    width: 100%;
  }
}
</style>